/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPlaceBalloonType {
  Geofence = 0,
  Hotspot
}
